"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceType = exports.SourceType = void 0;
var SourceType;
(function (SourceType) {
    SourceType["default"] = "";
    SourceType["startBalance"] = "starting balance";
    SourceType["startBalanceAdjust"] = "starting balance - adjustment";
    SourceType["billingAdjustment"] = "billing - adjustment";
    SourceType["claim"] = "claim";
    SourceType["claimAdjust"] = "claim - adjustment";
    SourceType["order"] = "order";
    SourceType["orderAdjust"] = "order - adjustment";
    SourceType["OrderTrackingCost"] = "Order - Tracking Cost";
    SourceType["OrderTrackingCostAdjust"] = "Order Tracking Cost - adjustment";
    SourceType["posfee"] = "POS fee";
    SourceType["posfeeAdjust"] = "POS fee - adjustment";
    SourceType["purchaseOrder"] = "purchase order";
    SourceType["dirfee"] = "DIR fee";
    SourceType["dirfeeAdjust"] = "DIR fee - adjustment";
    SourceType["imbfee"] = "service fee";
    SourceType["imbfeeAdjust"] = "service fee - adjustment";
    SourceType["transactionfee"] = "transaction fee";
    SourceType["transactionfeeAdjust"] = "transaction fee - adjustment";
    SourceType["deposit"] = "deposit";
    SourceType["dispersement"] = "dispersement";
    SourceType["dispersementAdjust"] = "dispersement - adjustment";
    SourceType["claimManual"] = "claim - manual insert";
    SourceType["imbfeeManual"] = "service fee - manual insert";
    SourceType["transactionFeeManual"] = "transaction fee - manual insert";
    SourceType["copayClaim"] = "copay claim";
    SourceType["tmpCopayCredit"] = "TMP copay credit";
    SourceType["copay"] = "Copay"; // D-002.830
})(SourceType = exports.SourceType || (exports.SourceType = {}));
// not used anymore - vendor name not hardcoded
// export enum VendorType {
//   optum = "OPTUM",
//   qcp = "QCP",
//   imb = "TMP"
// }
var ReferenceType;
(function (ReferenceType) {
    ReferenceType["default"] = "";
    ReferenceType["rxnumber"] = "RXNumber";
    ReferenceType["ordernumber"] = "OrderNumber";
    ReferenceType["checknumber"] = "CheckNumber";
    ReferenceType["adjustment"] = "balance adjustment";
    ReferenceType["headernumber"] = "EOB Id";
    ReferenceType["invoicenumber"] = "InvoiceNumber";
    ReferenceType["ClaimOrderId"] = "Claim Order Id";
    ReferenceType["SiteId"] = "Pharmacy Id";
    ReferenceType["PatientId"] = "Patient Id";
})(ReferenceType = exports.ReferenceType || (exports.ReferenceType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/ledger.ts
// module id = 3719
// module chunks = 0